import { render, staticRenderFns } from "./TicketsTable.vue?vue&type=template&id=94ac85e6&scoped=true&"
import script from "./TicketsTable.vue?vue&type=script&lang=js&"
export * from "./TicketsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ac85e6",
  null
  
)

export default component.exports